module.exports = __webpack_public_path__ + "img/10.8e3af639.png";